import React, { Component } from "react";
import { Col, Container, Row, Button, Image } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import SuperAdminSMS from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminCall from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import AboutSection from "./ProfileSections/AboutSection";
import HealthAndSanitationSection from "./ProfileSections/HealthAndSanitationSection";
import CuisineInformationSection from "./ProfileSections/CuisineInformationSection";
import SubscriptionSection from "./ProfileSections/SubscriptionSection";
import moment from "moment";

import isEmpty from "../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReferralsProfile from "./ProfileSections/ReferralsProfile";
// import { clear_all_errors } from "../../../store/actions/errorActions";
// import { logOutUser } from "../../../store/actions/authAction";

export class VendorProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: 1,
    };
  }

  handleTabsChange = (tabs) => (e) => {
    this.setState({ tabs: tabs });
  };

  render() {
    const { tabs } = this.state;
    const devided =
      this.props.onboarding && this.props.onboarding.page_completed_till / 21;
    const finalValue = devided * 100;
    const percentage = Math.round(finalValue);

    const monData =
      this.props.onboarding &&
      this.props.onboarding.monday &&
      this.props.onboarding.monday.multipleHours;
    const tueData =
      this.props.onboarding &&
      this.props.onboarding.tuesday &&
      this.props.onboarding.tuesday.multipleHours;
    const wedData =
      this.props.onboarding &&
      this.props.onboarding.wednesday &&
      this.props.onboarding.wednesday.multipleHours;
    const thuData =
      this.props.onboarding &&
      this.props.onboarding.thursday &&
      this.props.onboarding.thursday.multipleHours;
    const friData =
      this.props.onboarding &&
      this.props.onboarding.friday &&
      this.props.onboarding.friday.multipleHours;
    const satData =
      this.props.onboarding &&
      this.props.onboarding.saturday &&
      this.props.onboarding.saturday.multipleHours;
    const sunData =
      this.props.onboarding &&
      this.props.onboarding.sunday &&
      this.props.onboarding.sunday.multipleHours;

    const country_code = this.props.auth.user.VendorUser.country_code;
    const mobile_number = this.props.auth.user.VendorUser.mobile_number;

    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/"
                displayText="Back"
              />
              <Col lg={12}>
                <Row className="align-items-center">
                  <Col md={12}>
                    <div className="f24_700_HelveticaNeue pb-4">Profile</div>
                  </Col>
                  <Col lg={5} xs={8} className="pb-3 mt-4">
                    <div className="d-flex align-items-center">
                      <div className="enIMG75 mr-3">
                        <Image
                          src={
                            this.props.onboarding &&
                            this.props.onboarding.logo_url
                          }
                          alt="Business Logo"
                          title="Business Logo"
                          className="w-100 h-100"
                        />
                      </div>
                      <div>
                        <div className="f20-700">
                          {this.props.onboarding &&
                            this.props.onboarding.restaurant_name}
                        </div>
                        <div className="f12-700">Hours of Openings</div>
                        {this.props?.onboarding?.are_you_open_24_x_7 ? (
                          <div className="f12-700">Open 24*7</div>
                        ) : (
                          <div className="f12-700">
                            {moment().format("dddd") === "Sunday" ? (
                              <React.Fragment>
                                {moment(
                                  sunData && sunData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  sunData && sunData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Monday" ? (
                              <React.Fragment>
                                {moment(
                                  monData && monData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  monData && monData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Tuesday" ? (
                              <React.Fragment>
                                {moment(
                                  tueData && tueData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  tueData && tueData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Wednesday" ? (
                              <React.Fragment>
                                {moment(
                                  wedData && wedData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  wedData && wedData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Thursday" ? (
                              <React.Fragment>
                                {moment(
                                  thuData && thuData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  thuData && thuData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Friday" ? (
                              <React.Fragment>
                                {moment(
                                  friData && friData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  friData && friData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                            {moment().format("dddd") === "Saturday" ? (
                              <React.Fragment>
                                {moment(
                                  satData && satData[0].opening_time
                                ).format("hh:mm A")}
                                &nbsp;to&nbsp;
                                {moment(
                                  satData && satData.slice(-1)[0].closing_time
                                ).format("hh:mm A")}
                              </React.Fragment>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    xs={4}
                    className="d-flex justify-content-start pb-3 mt-4"
                    style={{ textAlign: "center" }}
                  >
                    <div className="d-flex justify-content-start align-items-center flex-column">
                      <h4 className="f16-700 mb-2">Profile Completion</h4>
                      <div className="progressCircleTbl">
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                          styles={buildStyles({
                            pathColor: `#EE3A23`,
                            textColor: "#EE3A23",
                            trailColor: "#d6d6d6",
                            backgroundColor: "#3e98c7",
                          })}
                        />
                      </div>
                      {/* <p className="font_16_r c_red mt-2">Profile Completion</p> */}
                    </div>
                  </Col>
                  {/* <Col lg={3} className="pb-3">
                    <div className="d-flex flex-wrap"> */}
                  {/* <SuperAdminCall /> */}
                  {/* <CallingButtonPopup
                        buttonClass="smallButton"
                        // sendData={dinerInfo}
                      /> */}
                  {/* <Button variant="link" className="enIconBtn mr-3">
                        <Image
                          src={require("../../../assets/images/UserManagement/forum.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <SuperAdminSMS
                        actionBy={"vendor"}
                        number={this.props.auth.user.VendorUser.mobile_number}
                      /> */}
                  {/* </div>
                  </Col> */}
                </Row>
                <div className="d-flex align-items-center py-5">
                  <Button
                    variant="link"
                    className={`px-0 mr-5 text-grayLink f12-500 ${
                      tabs === 1 ? "active" : ""
                    }`}
                    onClick={this.handleTabsChange(1)}
                  >
                    About
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-5 text-grayLink f12-500 ${
                      tabs === 2 ? "active" : ""
                    }`}
                    onClick={this.handleTabsChange(2)}
                  >
                    Health and Sanitation
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-5 text-grayLink f12-500 ${
                      tabs === 3 ? "active" : ""
                    }`}
                    onClick={this.handleTabsChange(3)}
                  >
                    Cuisine Information
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-5 text-grayLink f12-500 ${
                      tabs === 4 ? "active" : ""
                    }`}
                    onClick={this.handleTabsChange(4)}
                  >
                    Subscription
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 text-grayLink f12-500 ${
                      tabs === 5 ? "active" : ""
                    }`}
                    onClick={this.handleTabsChange(5)}
                  >
                    My Referrals
                  </Button>
                </div>
                {tabs === 1 && (
                  <AboutSection
                    vendor={this.props.onboarding && this.props.onboarding}
                  />
                )}
                {tabs === 2 && (
                  <HealthAndSanitationSection
                    vendor={this.props.onboarding && this.props.onboarding}
                  />
                )}
                {tabs === 3 && (
                  <CuisineInformationSection
                    vendor={this.props.onboarding && this.props.onboarding}
                  />
                )}
                {tabs === 4 && (
                  <SubscriptionSection
                    vendor={this.props.onboarding && this.props.onboarding}
                  />
                )}

                {tabs === 5 && (
                  <ReferralsProfile
                    vendor={this.props.onboarding && this.props.onboarding}
                  />
                )}
              </Col>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

VendorProfile.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, null)(withRouter(VendorProfile));
